"use client";
import Image from "next/image";
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { IoMdClose } from "react-icons/io";
import { ImArrowRight, ImArrowLeft } from "react-icons/im";

export default function DemoImageViewer(props) {
  const gallery = props.data;
  const selectedImage = props.selectedImage;
  const selectedIndex = props.selectedDemoImageIndex;
  const [currentIndex, setCurrentIndex] = useState(selectedIndex);
  const [mainImage, setMainImage] = useState(selectedImage.fileLink);

  const nextImage = () => {
    let totalImageCount = gallery.length;
    if (currentIndex < totalImageCount - 1) {
      setCurrentIndex(currentIndex + 1);
      setMainImage(gallery[currentIndex + 1].fileLink);
    } else {
      setCurrentIndex(0);
      setMainImage(gallery[0].fileLink);
    }
  };

  const prevImage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setMainImage(gallery[currentIndex - 1].fileLink);
    } else {
      setCurrentIndex(gallery.length - 1);
      setMainImage(gallery[gallery.length - 1].fileLink);
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => nextImage(),
    onSwipedRight: () => prevImage(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true, // Optional, enable mouse events
  });

  return (
    <div className="image-viewer">
      <div className="image-viewer-head">
        <div className="button-wrapper">
          <button onClick={prevImage}>
            <ImArrowLeft />
          </button>
          <button onClick={nextImage}>
            <ImArrowRight />
          </button>
        </div>
        <button onClick={() => props.close()}>
          <IoMdClose />
        </button>
      </div>
      <div className="image-viewer-main" {...handlers}>
        <Image
          src={mainImage}
          width={1920}
          height={1080}
          alt={selectedImage.altText || "Demo Image"}
        />
      </div>
    </div>
  );
}
